import i18n from '@/i18n';

export const getChartTargetName = (item, isCollectionValue) => {
  const { objectDisplayName, productName, statisticsType } = item;
  const subName = objectDisplayName ? `.${objectDisplayName}` : '';
  const labelType = isCollectionValue
    ? ''
    : `(${i18n.global.t(`label.${statisticsType.toLowerCase()}`)})`;
  return [productName, subName, labelType].join('');
};

export const convertRawDataToDataChart = ({
  rawData,
  isCollectionValue = false,
  hasIndividual = false
}) => {
  return rawData.map((item) => ({
    key: hasIndividual ? `${item.productName}_${item.objectName}` : item.productResourceId,
    name: getChartTargetName(item, isCollectionValue),
    data: item.perfData.map(({ ts, value }) => [ts, value]),
    productName: item.productName,
    objectDisplayName: item.objectDisplayName,
    statisticsType: item.statisticsType,
    metricUnit: item.metricUnit,
    metricName: item.metricName
  }));
};

export const checkIsCollectionValue = (interval, minInterval, productType) => {
  const product = productType.toLowerCase();
  if (product === 'cdn') return true;
  return parseInt(interval) <= parseInt(minInterval);
};

const isProductFromASG = (item) => {
  return (
    Object.prototype.hasOwnProperty.call(item, 'productList') && Array.isArray(item.productList)
  );
};

const convertObjProduct = (item) => {
  return {
    text: item.productName,
    key: item.key || item.resourceId || item.productResourceId,
    productSq: item.productId || item.productSq,
    idx: item.idx,
    check: item.check
  };
};

export const getProducts = (targets, shouldConvert = true) => {
  const products = [];

  for (const item of targets) {
    if (!isProductFromASG(item)) {
      products.push(shouldConvert ? convertObjProduct(item) : item);
    } else {
      for (const group of item.productList) {
        products.push(shouldConvert ? convertObjProduct(group) : group);
      }
    }
  }

  return products;
};

export const getProductSqs = (targets) => {
  const products = getProducts(targets);

  return products.map((product) => product.productSq);
};

export const getParamChart = ({
  metric,
  isDownload = false,
  k8s,
  hasSubType,
  objectType,
  subTypeCode,
  selectedTargets = [],
  listIndividuals = [],
  startTime,
  endTime,
  statisticsTypeList = [],
  selectedIndividualItems = []
}) => {
  const params = {
    metricDataConditionConsole: {
      metricKey: metric.metricKey,
      objectType: subTypeCode || '',
      productResourceInfosConsole: [],
      statisticsPeriod: null,
      statisticsTypeList: isDownload ? null : statisticsTypeList
    },
    queryStartDt: startTime,
    queryEndDt: endTime
  };

  if (k8s) {
    params.metricDataConditionConsole.productSubType = subTypeCode;
    params.metricDataConditionConsole.productSubName = selectedTargets.map(
      (item) => item.objectName || item.productSubName
    );
    params.metricDataConditionConsole.objectType = objectType;
  }

  let _objectList = [];
  if (isDownload) {
    _objectList = listIndividuals;
  }
  if (!isDownload && ((metric.isObjectExist === 'Y' && !hasSubType) || k8s)) {
    _objectList = [...selectedIndividualItems];
  }

  selectedTargets.forEach((item) => {
    let resourceIdentifier = item.resourceId || item.productResourceId;

    if (resourceIdentifier) {
      addTarget(params, item, resourceIdentifier, _objectList, metric, hasSubType, k8s);
    }

    if (isProductFromASG(item)) {
      item.productList.forEach((product) =>
        addTarget(params, item, product.productResourceId, _objectList, metric, hasSubType, k8s)
      );
    }
  });

  return params;
};

const addTarget = (params, item, resourceIdentifier, _objectList, metric, hasSubType, k8s) => {
  const target = {
    productResourceId: resourceIdentifier,
    objectList: getObjectList(item, _objectList, metric, hasSubType, k8s)
  };
  params.metricDataConditionConsole.productResourceInfosConsole.push(target);
};

const getObjectList = (item, _objectList, metric, hasSubType, k8s) => {
  return metric.isObjectExist === 'Y' && hasSubType && item.objectName && !k8s
    ? [item.objectName]
    : _objectList;
};
